import { useRef, useState } from "react";
import styles from "./style.module.scss";
import DynamicForm from "@mavichpe/dynamic-forms";
import BarcodeFormFormConfig from "./form";
import AddProductToDocumentOffCanvas from "@components/layout/Offcanvas/AddProductToDocumentOffCanvas";
import { EDocumentProductDataType } from "@/formTypes/EDocumentProductDataType";
import { OpenAddProductPubSub } from "@utils/pubsubs/PubSub";
import { Button } from "reactstrap";
import { useAppSelector } from "@/store/hooks";
import { QRCodeSVG } from "qrcode.react";
import cx from "classnames";

type PrintableTagProps = {}

const PrintableTag = (props: PrintableTagProps) => {
  const [productData, setProductData] = useState<EDocumentProductDataType>();
  const currencySymbol = useAppSelector((state) => state.currency.currencySymbol);

  const qrValue =
    productData?.codigo && productData?.price
      ? `p${productData.codigo} ${productData.price}`
      : "";

  const onProductSelected = (product: EDocumentProductDataType) => {
    OpenAddProductPubSub.publish({ openOffCanvas: false });
    setProductData(product);
  };

  const pasteProduct = () => {
    try {
      const pasteProduct = JSON.parse((window as any).toCopyProduct);
      setProductData(pasteProduct);
    } catch (e) {
      console.error("No hay producto en el portapapeles interno.", e);
    }
  };

  const copyProduct = () => {
    (window as any).toCopyProduct = JSON.stringify(productData);
  };

  return (
    <div className={cx({
      [styles.container]: true,
      "hide-from-print": !productData?.codigo,
    })}>
      <div className={styles.qrBox}>
        {qrValue && (
          <QRCodeSVG
            className={styles.barcode}
            value={qrValue}
            size={80}           // tamaño del QR (px)
            level="M"           // corrección de error: L, M, Q, H
            marginSize={0}
            bgColor="#ffffff"
            fgColor="#000000"
          />
        )}
      </div>

      {productData?.productId && (
        <div className={styles.productDataWrapper}>
          <div className={styles.productData}>
            <div>
              <b>{productData?.codigo}</b>
            </div>
            <div>
              <b>
                {currencySymbol} {productData?.price}
              </b>
            </div>
          </div>
          <div className={styles.descriptionProduct}>
            {productData.description}
          </div>
        </div>
      )}

      <div className={styles.actions}>
        <AddProductToDocumentOffCanvas
          hideTemplate
          hideTemporal
          editablePrice
          calculateTaxes
          productSelection
          defaultSearchType="general"
          btnColor={productData?.productId ? "success" : "primary"}
          onProductSelect={onProductSelected}
        >
          Seleccionar
        </AddProductToDocumentOffCanvas>

        {productData?.productId && (
          <Button
            color="danger"
            type="button"
            onClick={() => setProductData({} as EDocumentProductDataType)}
          >
            Borrar
          </Button>
        )}

        {productData?.productId && (
          <Button color="warning" type="button" onClick={copyProduct}>
            Copiar
          </Button>
        )}

        {!productData?.productId && (
          <Button color="success" type="button" onClick={pasteProduct}>
            Pegar
          </Button>
        )}
      </div>
    </div>
  );
};

export default PrintableTag;